import { Button } from 'antd';
import { ButtonProps } from 'antd/lib/button';
import React, { FC, useCallback, useRef } from 'react';
import { stopDefaultEvents } from '../../utils/DataAccessUtils';

const OWButton: FC<ButtonProps> = ({
	loading,
	disabled,
	onClick,
	children,
	htmlType,
	form: formId,
	...rest
}) => {
	const isHandling = useRef(false);

	const handleClick = useCallback(
		(e: React.MouseEvent<HTMLButtonElement>) => {
			if (isHandling.current || loading || disabled) return;
			isHandling.current = true;

			if (htmlType === 'submit' && formId) {
				stopDefaultEvents(e);
				const formEl = document.getElementById(formId as string) as HTMLFormElement;
				if (formEl) {
					formEl.requestSubmit();
				}
			} else {
				if (onClick) {
					onClick(e);
				}
			}

			// Reset after the current event loop tick. If the action triggered loading
			// state, disabled={loading} will block clicks until it completes. If not
			// (e.g. form validation failed), this allows the user to retry.
			setTimeout(() => {
				isHandling.current = false;
			}, 0);
		},
		[loading, disabled, onClick, htmlType, formId]
	);

	return (
		<Button
			loading={loading as boolean}
			disabled={!!(loading || disabled)}
			onClick={handleClick}
			htmlType="button"
			{...rest}
		>
			{children}
		</Button>
	);
};

export { OWButton };
export default OWButton;
